module.exports = __webpack_public_path__ + "static/media/negro-swam.226b060c.jpg";